import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { CommonStyles } from "../../commons/CommonStyles";
import { DeleteEnterprise, } from "../../services/ReasonService";
import { GetEnterpriseData } from "../../services/EnterpriseDataCallsService.js";
import {
  GetUtilitiesCorreosIdSubscriptionEnterpriseTycPrivacyUrls,
} from "../../services/UtilitiesCallsService";
import { CorreosButton } from "../CorreosButton/CorreosButton";
import { getErrorMessage } from "../../commons/Utils";
import { useTranslation } from "react-i18next";
import { Alerts } from "../Alerts/Alerts";
import history from "../../services/history.js";
import { BasicDialog } from "../CommonComponents/BasicDialog";
import { isResultOk, showAlert } from "../../commons/FormManager";

export function EnterpriseDelete(props) {
  const { setUpdateEnterprises, idEnterprise } = props;
  const commonClasses = CommonStyles();
  const { t } = useTranslation();
  const [circularProgress, setCircularProgress] = useState(false);
  const [circularProgressDeleting, setCircularProgressDeleting] =
    useState(false);
  const [enterpriseSubscriptions, setEnterpriseSubcriptions] = useState([]);
  const [alert, setAlert] = useState({
    open: false,
    color: "",
    message: "",
  });
  const [openPopup, setOpenPopup] = useState(false);

  useEffect(() => {
    if (idEnterprise) {
      preparePage();
    }
  }, [idEnterprise]);

  useEffect(() => { }, [circularProgressDeleting]);

  const finishOperation = (color, message) => {
    setAlert({
      open: true,
      color,
      message,
    });
  };

  const preparePage = () => {
    setCircularProgress(true);
    let getEnterpriseIdEnterprise = GetEnterpriseData(idEnterprise);
    let getUtilitiesCorreosIdSubscriptionEnterpriseTycPrivacyUrls = GetUtilitiesCorreosIdSubscriptionEnterpriseTycPrivacyUrls(idEnterprise);
    Promise.all([getEnterpriseIdEnterprise, getUtilitiesCorreosIdSubscriptionEnterpriseTycPrivacyUrls]).then((results) => {
      let enterpriseData = results[0];
      let enterpriseSubscriptions = results[1];
      if (isResultOk([enterpriseData, enterpriseSubscriptions])) {
        setEnterpriseSubcriptions(enterpriseSubscriptions);
        setCircularProgress(false);
      } else {
        showAlert([enterpriseData, enterpriseSubscriptions], finishOperation, t);
        setCircularProgress(false);
      }
    });
  };

  const handleSend = () => {
    setOpenPopup(true);
  };

  const confirmDeleteEnterprise = () => {
    setCircularProgressDeleting(true);
    DeleteEnterprise(idEnterprise).then((response) => {
      if (response && !response.Status) {
        finishOperation("success", t("enterpriseDeleteAlertMessageSuccess"));
        setCircularProgressDeleting(false);
        setUpdateEnterprises();
        let redirect = "/Index";
        history.push(redirect);
      } else {
        finishOperation("error", getErrorMessage(response, t));
        setCircularProgressDeleting(false);
      }
    });
  };

  return (
    <Grid>
      <Alerts alert={alert} setAlert={setAlert}></Alerts>
      <BasicDialog
        open={openPopup}
        setOpen={setOpenPopup}
        title={t("warning")}
        text={t("enterpriseDeleteAlertLastWarning")}
        action={confirmDeleteEnterprise}
      />
      <Grid>
        <Grid container>
          <Grid style={{ marginTop: "1.5em" }}>
            <Typography
              variant="h6"
              className={commonClasses.title}
              style={{ textAlign: "left", marginTop: "1em" }}
            >
              {t("enterpriseDeleteEnterpriseServicesTitle")}
            </Typography>
            <Typography
              className={commonClasses.textDiv}
              style={{ textAlign: "left" }}
            >
              {circularProgress ? (
                <CircularProgress />
              ) : (
                <ul>
                  {enterpriseSubscriptions.map((app) => (
                    <li>{app.application}</li>
                  ))}{" "}
                </ul>
              )}
              <Typography
                variant="h6"
                className={commonClasses.title}
                style={{ textAlign: "left" }}
              >
                {t("accountCancelDisableAccountListTitle")}
              </Typography>
              <ul>
                <li>{t("enterpriseDeleteEnterpriseText")}</li>
              </ul>
            </Typography>
          </Grid>
          <Grid
            container
            item
            spacing={1}
            xs={12}
            className={commonClasses.dialogButtonContainer}
          >
            <Grid item xs={12}>
              <CorreosButton
                color="secondary"
                onClick={handleSend}
                circularProgress={circularProgressDeleting}
              >
                {t("enterpriseDeleteButtonText")}
              </CorreosButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
